import Vue from 'vue'
import VueRouter from 'vue-router'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
import { isUserLoggedIn, getUserData, getHomeRouteForLoggedInUser } from '@/auth/utils'

import pages from './routes/pages'
import others from './routes/others'
import rubiscoDashboard from './routes/rubisco-dashboard'
import rubiscoCatalogoProdotti from './routes/rubisco-catalogo-prodotti'
import rubiscoLaTuaAzienda from './routes/rubisco-la-tua-azienda'
import rubiscoCrm from './routes/rubisco-crm'
import demo from './routes/demo-mio'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    { path: '/', redirect: { name: 'rubisco-dashboard' } },
    ...pages,
    ...others,
    ...rubiscoDashboard,
    ...rubiscoCatalogoProdotti,
    ...rubiscoLaTuaAzienda,
    ...rubiscoCrm,
    ...demo,
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn) return next({ name: 'auth-login' })

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const userData = getUserData()
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null))
  }

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
